export const DISABLED_ADD_NEW_BUTTON = 'addNewButton';
export const DISABLED_DELETE_SELECTED_BUTTON = 'deleteSelectedButton';

export const DISABLED_FORM_SAVE_BUTTON = 'saveButton';
export const DISABLED_FORM_DELETE_BUTTON = 'deleteButton';
